import type { ComputedRef, InjectionKey } from 'vue'
import type { TMenuListbox } from '@/types/dropdown'

export const menuListboxKey: InjectionKey<ComputedRef<TMenuListbox | null>> = Symbol('menu-listbox')
